import { z } from 'zod';

import type { ApplicationInstanceSpec } from '../types';

/** 应用实例交付规格：与后端 ApplicationInstanceSpec 对齐 */
export const AppInstanceSpecSchema = z.custom<ApplicationInstanceSpec>((val) => val != null && typeof val === 'object');

export type AppInstanceSpec = ApplicationInstanceSpec;

export type AppInstanceApiPayload = ApplicationInstanceSpec & Record<string, unknown>;
